import { configureStore } from "@reduxjs/toolkit";

import {
  MessagesReducer,
  RepliesReducer,
  PropertyReducer,
  DatePickerReducer,
  WindowReducer,
  GalleryReducer,
  PolicyReducer,
  BadgeSwitchReducer,
  VideosReducer,
  UnitReducer,
  MascotSettingsReducer,
  ParamsReducer,
  OptionBoxReducer,
  ScheduleTourReducer,
  StandaloneReducer,
} from "slices";

const store = configureStore({
  reducer: {
    messages: MessagesReducer,
    replies: RepliesReducer,
    property: PropertyReducer,
    datepicker: DatePickerReducer,
    window: WindowReducer,
    gallery: GalleryReducer,
    units: UnitReducer,
    policy: PolicyReducer,
    badgeSwitch: BadgeSwitchReducer,
    videos: VideosReducer,
    mascotSetting: MascotSettingsReducer,
    params: ParamsReducer,
    optionBox: OptionBoxReducer,
    scheduleTour: ScheduleTourReducer,
    standalone: StandaloneReducer,
  },
});

export default store;
